<template>
    <div>
        <table v-if="relatorio.pivot && relatorio.result && relatorio.result.columns.length == 3" class="table table-hover table-sm table-responsive-md bg-light mb-0">
          <thead class="">
            <tr class="">
              <th>
                {{ relatorio.result.columns[0].title }}
              </th>
              <th v-for="(coluna, icx) in listar(relatorio.result.columns[1])" :key="icx" class="text-right ">
                {{ coluna.label }}
              </th>
              <th class="text-right">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-light" v-for="(valores, linha, ilx) in pivotGroups(groupedData)" :key="ilx">
              <td>{{ linha }}</td>
              <td v-for="(coluna, icx) in listar(relatorio.result.columns[1])" :key="icx" class="text-right">
                {{ formatar(relatorio.result.columns[2], totalizar_pivot(valores, relatorio.result.columns[1], coluna.label)) }}
              </td>
              <th class="text-right">
                {{ formatar(relatorio.result.columns[2], totalizar_pivot(valores)) }}
              </th>
            </tr>
          </tbody>
          <tbody>
            <tr class="table-secondary">
              <th>TOTAL</th>
              
              <th v-for="(coluna, icx) in listar(relatorio.result.columns[1])" :key="icx" class="text-right">
                {{ formatar(relatorio.result.columns[2], totalizar_pivot(dadosFiltrados, relatorio.result.columns[1], coluna.label)) }}
              </th>
              <th class="text-right">
                {{ formatar(relatorio.result.columns[2], totalizar_pivot(dadosFiltrados)) }}
              </th>
            </tr>
          </tbody>
        </table>

        <table v-if="relatorio && relatorio.result && !relatorio.pivot" class="table table-hover table-sm table-responsive-md bg-light mb-0" >
          <thead>
            <tr>
              
              <template v-for="(coluna, ic) in relatorio.result.columns">

                <th :key="'C' + ic" :class="'text-' + coluna.align">
                  <a href="#" @click.prevent="addFiltroModal(coluna)" class="card-link">{{ coluna.title }}</a>
                </th>
                <th :class="'text-' + coluna.align" :key="'percent' + ic" v-if="coluna.percent">
                  %
                </th>
              </template>

            </tr>
          </thead>

          <tbody v-if="relatorio.result.group_cols.length == 0">
            <tr v-for="(linha, il) in groupedData" :key="il">
              <template v-for="(coluna, ic) in relatorio.result.columns">
                <td :key="ic" :class="'text-' + coluna.align" :style="printableFont" >{{ formatar ( coluna, linha[coluna.name] ) }}</td>
                <td v-if="coluna.percent" :key="'percent-l' + ic" class="text-right small">
                  {{ 
                    $util.formatMoeda(
                      calc_percent(
                        totalizar (groupedData, coluna.name, relatorio.result.group_cols.length), 
                        linha[coluna.name]
                      )
                    ) 
                  }}%
                </td>
              </template>
            </tr>
          </tbody>
          <!-- Relatório com 1 quebra -->
          <tbody v-else-if="relatorio.result.group_cols.length == 1">
            <template v-for="(g1, ig1, ig1_index) in groupedData">
              <tr :key="ig1" class="table-primary">
                <td colspan="10">
                  <a
                    class="card-link"
                    data-toggle="collapse"
                    :href="'.collapse1-' + ig1_index"
                    role="button"
                    v-if="1 == 0"
                    :style="printableFont"
                  >
                    <i class="far fa-minus-square mr-2"></i>
                  </a>
                  {{ ig1 }}
                </td>
              </tr>
              <tr v-for="(linha, il) in g1" :key="ig1 + '|' + il">
                <td
                  v-for="(coluna, ic) in relatorio.result.columns"
                  :key="ig1 + '|' + il + '|' + ic"
                  :class="'text-' + coluna.align"
                >
                  <a
                    href="#"
                    @click.prevent="addFiltro(coluna, linha[coluna.name])"
                    :style="printableFont"
                  >{{ formatar(coluna, linha[coluna.name]) }}</a>
                </td>
              </tr>
              <tr class="table-secondary" :key="'subtot-' + ig1 + '|' + ig1_index">
                <td
                  v-for="(coluna, ic) in relatorio.result.columns"
                  :key="'tot-' + ig1 + '|' + ic"
                  :class="'text-' + coluna.align"
                  :style="printableFont"
                >
                  <span
                    v-if="coluna.treat && coluna.type == 'value'"
                    :style="printableFont"
                  >{{ formatar ( coluna, totalizar (g1, coluna.name) ) }}</span>
                </td>
              </tr>
            </template>
          </tbody>

          <!-- Relatório com 2 quebras -->
          <tbody v-else-if="relatorio.result.group_cols.length == 2">
            <template v-for="(g1, ig1, ig1_index) in groupedData">
              <tr :key="ig1" class="table-primary">
                <td colspan="10">
                  <a
                    class="card-link"
                    data-toggle="collapse"
                    :href="'.collapse1-' + ig1_index"
                    role="button"
                    v-if="1 == 0"
                    :style="printableFont"
                  >
                    <i class="far fa-minus-square mr-2"></i>
                  </a>
                  {{ ig1 }}
                </td>
              </tr>
              <template v-for="(g2, ig2, ig2_index) in g1">
                <tr
                  :key="ig1 + '|' + ig2"
                  class="table-info collapse multi-collapse show"
                  :class="'collapse1-' + ig1_index"
                >
                  <td colspan="10">
                    <a
                      class="card-link"
                      data-toggle="collapse"
                      :href="'.collapse2-' + ig1_index + '-' + ig2_index"
                      role="button"
                      v-if="1 == 0"
                      :style="printableFont"
                    >
                      <i class="far fa-minus-square mr-2"></i>
                    </a>
                    {{ ig2 }}
                  </td>
                </tr>
                <tr
                  v-for="(linha, il) in g2"
                  :key="ig1 + '|' + ig2 + '|' + il"
                  class="collapse multi-collapse show"
                  :class="'collapse1-' + ig1_index + ' collapse2-' + ig1_index + '-' + ig2_index"
                >
                  <td
                    v-for="(coluna, ic) in relatorio.result.columns"
                    :key="ig1 + '|' + ig2 + '|' + il + '|' + ic"
                    :class="'text-' + coluna.align"
                    :style="printableFont"
                  >
                    <a
                      href="#"
                      @click.prevent="addFiltro(coluna, linha[coluna.name])"
                      :style="printableFont"
                    >{{ formatar(coluna, linha[coluna.name]) }}</a>
                  </td>
                </tr>
                <tr class="table-secondary" :key="'subtot-' + ig1 + '|' + ig2_index">
                  <td
                    v-for="(coluna, ic) in relatorio.result.columns"
                    :key="'tot-' + ig1 + '|' + ig2 + '|' + ic"
                    :class="'text-' + coluna.align"
                  >
                    <span
                      v-if="coluna.treat && coluna.type == 'value' && g2"
                    >{{ formatar ( coluna, totalizar (g2, coluna.name) ) }}</span>
                  </td>
                </tr>
              </template>
              <tr class="table-dark text-dark" :key="'subtot-' + ig1">
                <td
                  v-for="(coluna, ic) in relatorio.result.columns"
                  :key="'tot-' + ig1 + '|' + ic"
                  :class="'text-' + coluna.align"
                  :style="printableFont"
                >
                  <span
                    v-if="coluna.treat && coluna.type == 'value'"
                    :style="printableFont"
                  >{{ formatar ( coluna, totalizar (g1, coluna.name, 1) ) }}</span>
                </td>
              </tr>
            </template>
          </tbody>

          <!-- Totalização Final -->
          <tbody class="table-secondary" v-if="tem_totalizacao">
            <tr>
              <template v-for="(coluna, ic) in relatorio.result.columns">
                <th :key="'total-' + ic" :class="'text-' + coluna.align" :style="printableFont">
                  <span
                    v-if="coluna.treat && coluna.type == 'value'"
                    :style="printableFont"
                  >{{ formatar ( coluna, totalizar (groupedData, coluna.name, relatorio.result.group_cols.length) ) }}</span>
                  <span v-else-if="!ic">TOTAL</span>
                </th>
                <th :class="'text-' + coluna.align" :key="'percent' + ic" v-if="coluna.percent">
                </th>
              </template>

                
            </tr>
          </tbody>
        </table>

    </div>
</template>

<script>
import _ from 'lodash';

export default {
    data() { 
        return { 
            filtros: [],
            printableFont: {},
        }
    },

    props: ['relatorio', 'config'],

    computed: { 
      tem_totalizacao: function() { 
        if ( !this.relatorio || !this.relatorio.result || !this.relatorio.result.columns )
          return true;

        return this.relatorio.result.columns.findIndex(item => item.treat && item.type == 'value') >= 0;
      },

      rGroups: function() {
        if (!this.relatorio || !this.relatorio.result) return [];

        let groups = this.relatorio.result.group_cols;

        groups[4] = null;

        return groups;
      },

      groupedData: function() {
          if (!this.relatorio || !this.relatorio.result) return [];

          let dados = ( this.relatorio && this.relatorio.result && this.relatorio.result.data ) 
              ? this.relatorio.result.data
              : [];

          if ( this.config.filtros ) {
              dados = dados.filter(item => { 
                  return this.config.filtros.every(filtro => { 
                      return filtro.campo 
                          && filtro.campo.column_name
                          && item[filtro.campo.column_name] == filtro.valor;
                  });
              });
          }

          let grouped = dados.filter(item => {
              if (!this.filtros.length) return true;

              let nok = this.filtros.filter(filtro => {
              if (filtro.valor.length > 1) {
                  return !filtro.valor.find(vl => {
                      return item[filtro.campo.name] == vl;
                  });
              } else {
                  return item[filtro.campo.name] != filtro.valor;
              }
              });

              return !nok.length;
          });

          let groups = this.relatorio.result.group_cols.map(item => {
              return item.name;
          });

          if (groups.length) {
              grouped = grouped.reduce((r, o) => {
              groups
                  .reduce(
                  (group, key, i, { length }) =>
                      (group[o[key]] = group[o[key]] || (i + 1 === length ? [] : {})),
                  r
                  )
                  .push(o);

              return r;
              }, {});
          }
         
          return grouped;
      },

      dadosFiltrados: function () {
        if (!this.relatorio || !this.relatorio.result)
          return [];

        if ( this.over_limit )
          return this.relatorio.result.data;

        return this.relatorio.result.data.filter(item => {
          if (!this.filtros.length) return true;

          let nok = this.filtros.filter(filtro => {
            if (filtro.valor.length > 1) {
              if ( filtro.tipo == 'E' ) {
                return filtro.valor.find(vl => {
                  return item[filtro.campo.name] == vl;
                });
              } else {
                return !filtro.valor.find(vl => {
                  return item[filtro.campo.name] == vl;
                });
              }
            } else {
              if ( filtro.tipo == 'E' ) {
                return item[filtro.campo.name] == filtro.valor;
              } else {
                return item[filtro.campo.name] != filtro.valor;
              }
            }
          });

          return !nok.length;
        });
      },
    },

    methods: { 
        calc_percent (total, parte) { 
          if ( !total )
            return null;

          return ( parte / total ) * 100;
        },

        pivotGroups(groupedData) {
          return _.groupBy(groupedData, 'col0');
        },

        addFiltroModal(coluna) { 
            this.$emit('filtromodal', coluna);
        },

        addFiltro(coluna, valor) { 
            this.$emit('filtro', { coluna: coluna, valor: valor });
        },

        formatar(campo, valor) {
            if (!campo.format) return valor;

            switch (campo.type) {
                case "time":
                //$date = date_create($value);
                return this.$util.getFormatDate(valor);

                case "value":
                return this.$util.formatNumber(valor, campo.format);

                default:
                return valor;
            }
        },
        totalizar(dados, campo, flat = 0) {
            if (flat) {
                dados = _.flatMap(dados);
            }

            return dados.reduce((total, item) => {
                return total + parseFloat(item[campo]);
            }, 0);
        },

        listar(campo) {
          if (!campo || !this.relatorio.result) {
            return [];
          }

        return _.orderBy(
            _.map(
              _.uniqBy(this.relatorio.result.data, campo.name),
              (item) => {
                return { label: item[campo.name], selecionado: false };
              }
            ),
            "label"
          );
      },

      totalizar_pivot(dados, coluna = null, valor = null) {

        {
          return dados.filter(item => !coluna || item[coluna.name] == valor)
          .reduce((total, carry) => total + parseFloat(_.get(carry, this.relatorio.result.columns[2].name)), 0);
        }

      },
    }
}
</script>